import { Layer } from './layer';
import OlLayer from 'ol/layer/Layer.js';

import { createEmpty } from './layer_capabilities';

class StyleLayer extends Layer {
   
   constructor() {
        super(new OlLayer({}));       
        this.setCapabilities(createEmpty());
    }

}

const styleLayer = () => {    
    return new StyleLayer();
}

export { styleLayer, StyleLayer }